(function () {
  function destroyCarousel(swiperEl) {
    if (swiperEl._imgtextSwiper && typeof swiperEl._imgtextSwiper.destroy === 'function') {
      swiperEl._imgtextSwiper.destroy(true, true);
      swiperEl._imgtextSwiper = null;
    }
  }

  function shouldEnableCarousel(cardCount) {
    var isMobile = window.matchMedia('(max-width: 768px)').matches;
    return isMobile || cardCount > 3;
  }

  function initCarousel(root, swiperEl) {
    if (typeof Swiper === 'undefined') return;

    var cardCount =
      parseInt(swiperEl.getAttribute('data-card-count'), 10) ||
      swiperEl.querySelectorAll('.swiper-slide').length ||
      0;
    var groupKey = swiperEl.getAttribute('data-group-key');
    var group = swiperEl.closest('[data-oeh-imgtext-group]');
    var enableCarousel = shouldEnableCarousel(cardCount);

    if (!enableCarousel) {
      destroyCarousel(swiperEl);
      if (group) group.classList.remove('is-carousel-pc');
      return;
    }

    if (group) {
      if (cardCount > 3 && !window.matchMedia('(max-width: 768px)').matches) {
        group.classList.add('is-carousel-pc');
      } else {
        group.classList.remove('is-carousel-pc');
      }
    }

    if (swiperEl._imgtextSwiper) return;

    var isMobile = window.matchMedia('(max-width: 768px)').matches;
    var nextEl = group
      ? group.querySelector('[data-oeh-imgtext-next="' + groupKey + '"]')
      : root.querySelector('[data-oeh-imgtext-next="' + groupKey + '"]');
    var prevEl = group
      ? group.querySelector('[data-oeh-imgtext-prev="' + groupKey + '"]')
      : root.querySelector('[data-oeh-imgtext-prev="' + groupKey + '"]');

    swiperEl._imgtextSwiper = new Swiper(swiperEl, {
      slidesPerView: 'auto',
      slidesPerGroup: 1,
      spaceBetween: isMobile ? 16 : 24,
      speed: 500,
      watchOverflow: true,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl
      }
    });
  }

  function initRoot(root) {
    if (!root || root.dataset.imgtextInitialized === 'true') return;
    root.dataset.imgtextInitialized = 'true';

    root.querySelectorAll('[data-oeh-imgtext-carousel]').forEach(function (swiperEl) {
      initCarousel(root, swiperEl);
    });

    if (!root._imgtextResizeBound) {
      root._imgtextResizeBound = true;
      window.addEventListener('resize', function () {
        clearTimeout(root._imgtextResizeTimer);
        root._imgtextResizeTimer = setTimeout(function () {
          root.querySelectorAll('[data-oeh-imgtext-carousel]').forEach(function (swiperEl) {
            destroyCarousel(swiperEl);
          });
          delete root.dataset.imgtextInitialized;
          initRoot(root);
        }, 200);
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-oeh-stu-imgtext-root]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-oeh-stu-imgtext-root]');
    if (!root) return;

    root.querySelectorAll('[data-oeh-imgtext-carousel]').forEach(function (swiperEl) {
      destroyCarousel(swiperEl);
    });
    delete root.dataset.imgtextInitialized;
    delete root._imgtextResizeBound;
    initRoot(root);
  });
})();
